import { render } from "./overseas.vue?vue&type=template&id=13a37251&scoped=true"
import script from "./overseas.vue?vue&type=script&lang=js"
export * from "./overseas.vue?vue&type=script&lang=js"

import "./overseas.vue?vue&type=style&index=0&id=13a37251&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a37251"]])

export default __exports__